<template>
  <NavigationBar/>
  <div
      class="pt-20 min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-100 via-purple-100 to-pink-200 animate-gradient">
    <div
        class="relative bg-white/70 backdrop-blur-2xl shadow-2xl rounded-3xl p-6 sm:p-10 space-y-8 text-center w-full max-w-md mx-4 border border-white/50 animate-fade-in-up animate-float transition-all duration-700 hover:scale-105 hover:shadow-3xl hover:border-blue-200 group"
    >
      <!-- Floating Decorative Circles -->
      <div
          class="absolute -top-8 -left-8 w-24 h-24 bg-gradient-to-br from-blue-300 to-purple-200 rounded-full opacity-30 blur-2xl animate-pulse"></div>
      <div
          class="absolute -bottom-8 -right-8 w-28 h-28 bg-gradient-to-br from-pink-300 to-blue-200 rounded-full opacity-30 blur-2xl animate-pulse"></div>
      <!-- Header with Icon -->
      <div class="space-y-4 animate-bounce-in">
        <div class="flex justify-center">
          <div class="p-3 bg-blue-100 rounded-full shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
        </div>
        <h1 class="text-3xl font-extrabold text-gray-800 tracking-tight drop-shadow-sm">RCC Kit Enquiry</h1>
        <p class="text-gray-600 animate-fade-in animate-delay-200">Manage your enquiries and orders</p>
      </div>
      <!-- Action Buttons -->
      <div class="space-y-4">
        <button
            @click="goTo('CreateEnquiry')"
            class="w-full flex items-center justify-center py-4 px-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-xl shadow-md transition-all duration-300 group hover:scale-105 hover:shadow-2xl hover:-rotate-2 hover:border-blue-400 border border-transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg"
               class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:animate-wiggle"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          <span>Create Sales Order</span>
        </button>
        <button
            @click="goTo('enquiries')"
            class="w-full flex items-center justify-center py-4 px-6 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-xl shadow-md transition-all duration-300 group hover:scale-105 hover:shadow-2xl hover:rotate-1 hover:border-green-400 border border-transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg"
               class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:animate-bounce-x"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
          </svg>
          <span>List of Enquiries</span>
        </button>
        <button
            @click="goTo('ConfirmedOrders')"
            class="w-full flex items-center justify-center py-4 px-6 bg-gradient-to-r from-purple-500 to-purple-600 text-white font-semibold rounded-xl shadow-md transition-all duration-300 group hover:scale-105 hover:shadow-2xl hover:-rotate-1 hover:border-purple-400 border border-transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg"
               class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:animate-pulse"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
          <span>Orders Tracker</span>
        </button>
        <button
            @click="exitApp"
            class="w-full flex items-center justify-center py-4 px-6 bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold rounded-xl shadow-md transition-all duration-300 group hover:scale-105 hover:shadow-2xl hover:rotate-2 hover:border-red-400 border border-transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg"
               class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:animate-shake-x"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span>Exit</span>
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import NavigationBar from "@/components/NavigationBar.vue";

export default {
  name: "HomePage",
  components: {
    NavigationBar
  },
  methods: {
    goTo(route) {
      // Example: use Vue Router navigation
      this.$router.push({name: route});
    },
    checkUser() {
      let user = localStorage.getItem("user-info");
      if (!user) {
        this.$router.push({name: "Login"})
      }
    },
    exitApp() {
      // alert("Exiting App...");
      this.$router.push({name: 'Login'});
    }
  },
  mounted() {
    this.checkUser()
  }
}
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce-in {
  0% {
    transform: scale(0.7);
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes wiggle {
  0%, 100% {
    transform: rotate(-8deg);
  }
  50% {
    transform: rotate(8deg);
  }
}

@keyframes bounce-x {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(8px);
  }
}

@keyframes shake-x {
  0%, 100% {
    transform: translateX(0);
  }
  20%, 60% {
    transform: translateX(-6px);
  }
  40%, 80% {
    transform: translateX(6px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 0.7s both;
}

.animate-bounce-in {
  animation: bounce-in 0.8s;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-wiggle {
  animation: wiggle 0.5s;
}

.animate-bounce-x {
  animation: bounce-x 0.6s;
}

.animate-shake-x {
  animation: shake-x 0.5s;
}

.animate-pulse {
  animation: pulse 1.2s;
}

</style>
